import React from 'react';
import Error from './ErrorBoundaryView';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const { hasError } = this.state;

    if (hasError) {
      return <Error />;
    }

    const { children } = this.props ?? {};

    return children;
  }
}

export default ErrorBoundary;
